/**
 * Application configuration utilities
 */

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
export const APP_STORE_IOS_URL = import.meta.env.VITE_APP_STORE_IOS_URL
export const APP_STORE_ANDROID_URL = import.meta.env.VITE_APP_STORE_ANDROID_URL
export const GOOGLE_SCRIPT_URL = import.meta.env.VITE_GOOGLE_SCRIPT_URL || 'https://script.google.com/macros/s/AKfycby-C6Mdqxx_TjwiWCeNO4S61kHmifBMtPJWHjPHdsOK8EcCLSLzBe2XaU7PhYo29Gbfag/exec'
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

// Build version info from Cloudflare Pages
// CF_PAGES_COMMIT_SHA is exposed via Vite define in vite.config.ts
const commitSha = (import.meta.env.CF_PAGES_COMMIT_SHA as string) ||
  import.meta.env.VITE_BUILD_COMMIT_SHA ||
  null

export const BUILD_VERSION = import.meta.env.VITE_BUILD_VERSION ||
  (commitSha ? commitSha.substring(0, 7) : null) ||
  "dev"
export const BUILD_BRANCH = (import.meta.env.CF_PAGES_BRANCH as string) ||
  import.meta.env.VITE_BUILD_BRANCH ||
  "local"
export const BUILD_COMMIT_SHA = commitSha

/**
 * Check if waitlist mode is enabled
 * @returns true if VITE_WAITLIST_MODE is set to 'true', false otherwise
 */
export function getWaitlistMode(): boolean {
  return import.meta.env.VITE_WAITLIST_MODE === 'true'
}
